import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiSettings } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function TeamBirthdayCard() {

const femaleImg =
"https://randomuser.me/api/portraits/women/44.jpg";

return (

<div className="flex-fill birthday-wrapper">

{/* TEAM BIRTHDAY CARD */}

<Card className="birthday-card mb-3">

{/* <div className="settings-icon">
<FiSettings />
</div> */}

<Card.Body className="text-center">

<h5 className="birthday-title">Team Birthday</h5>

<div className="avatar-wrapper">
<img
src={femaleImg}
alt="female-user"
className="birthday-avatar"
/>
</div>

<h6 className="user-name">Andrew Jermia</h6>

<p className="user-role">IOS Developer</p>

<Button className="wish-btn">
Send Wishes
</Button>

</Card.Body>

</Card>

{/* LEAVE POLICY */}

<Card className="leave-card mb-3">

<Card.Body className="leave-body">

<div>
<h6 className="leave-title">Leave Policy</h6>
<p className="leave-text">Last Updated : Today</p>
</div>

<Button className="view-btn">
View All
</Button>

</Card.Body>

</Card>

{/* NEXT HOLIDAY */}

<Card className="holiday-card">

<Card.Body className="leave-body">

<div>
<h6 className="holiday-title">Next Holiday</h6>
<p className="holiday-text">
Diwali, 15 Sep 2025
</p>
</div>

<Link to="/holidays" className="text-decoration-none text-dark"     >
<Button className="view-btn-2">
View All
</Button>
</Link>

</Card.Body>

</Card>

<style>{`

/* MAIN */

.birthday-wrapper{
width:100%;
}

/* TEAM BIRTHDAY CARD */

.birthday-card{
position:relative;
border:none;
border-radius:8px;
background:linear-gradient(180deg,#2f3a42,#1f262c);
color:white;
overflow:hidden;
padding-top:10px;
}

.birthday-card::before{
content:"";
position:absolute;
top:-120px;
left:-80px;
width:300px;
height:300px;
background:rgba(255,255,255,0.05);
border-radius:50%;
}

/* TITLE */

.birthday-title{
font-size:16px;
font-weight:600;
margin-bottom:18px;
}

/* AVATAR */

.avatar-wrapper{
display:flex;
justify-content:center;
margin-bottom:8px;
}

.birthday-avatar{
width:65px;
height:65px;
border-radius:50%;
object-fit:cover;
border:3px solid #ff8ea1;
}

/* USER INFO */

.user-name{
font-size:15px;
font-weight:600;
margin-top:8px;
margin-bottom:2px;
}

.user-role{
font-size:13px;
color:#a8b3bc;
margin-bottom:12px;
}

/* BUTTON */

.wish-btn{
background:#ff6b1a;
border:none;
font-size:13px;
padding:6px 14px;
border-radius:6px;
}

// /* SETTINGS ICON */

// .settings-icon{
// position:absolute;
// right:-10px;
// top:45%;
// background:#ff6b1a;
// color:white;
// padding:8px;
// border-radius:4px;
// font-size:16px;
// }

/* LEAVE POLICY */

.leave-card{
background:#14596b;
border:none;
border-radius:8px;
color:white;
}

.leave-body{
display:flex;
align-items:center;
justify-content:space-between;
}

.leave-title{
font-size:16px;
margin-bottom:2px;
}

.leave-text{
font-size:14px;
margin:0;
color:#dbeafe;
}

/* NEXT HOLIDAY */

.holiday-card{
background:#ffc107;
border:none;
border-radius:8px;
}

.holiday-title{
font-size:15px;
font-weight:600;
margin-bottom:2px;
}

.holiday-text{
font-size:13px;
margin:0;
}

/* VIEW BUTTON */

.view-btn{
background:#ff6b1a;
border:none;
color:white;
font-size:13px;
padding:5px 12px;
border-radius:6px;
}
.view-btn-2{
background:white;
border:none;
color:black;
font-size:13px;
padding:5px 12px;
border-radius:6px;
}

`}</style>

</div>

);

}